import createClient from "openapi-fetch";
import type { paths } from "@/types/api";
import { clearToken, getToken } from "./auth";

const baseUrl = import.meta.env.VITE_API_BASE_URL || "http://localhost:3000";

export const api = createClient<paths>({ baseUrl });

api.use({
  onRequest({ request }) {
    const token = getToken();
    if (token) request.headers.set("Authorization", `Bearer ${token}`);
    return request;
  },
  onResponse({ response }) {
    if (response.status === 401) {
      clearToken();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return response;
  },
});

/**
 * Convenience helper for React Query: unwraps the openapi-fetch envelope and
 * throws on error so React Query treats it as a failed query.
 */
export async function unwrap<T>(
  promise: Promise<{ data?: T; error?: unknown; response: Response }>,
): Promise<T> {
  const { data, error, response } = await promise;
  if (error || !response.ok) {
    throw error ?? new Error(`HTTP ${response.status}`);
  }
  return data as T;
}
